// login (login, logout)
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import utils from './utils'

import { getBusinessInfoSignup, setToken } from './signup'
import { init } from 'src/service/firebase'

const status = utils.initStatus([
	'getPersonalDetails',
	'editPersonalDetails',
	'login',
	'getRefreshedToken',
	'forgotPassword',
	'resetPassword',
	'setPin',
	'unlockUsingPin',
])

const initialState = {
	currBranch: '',
	// Login
	user: {
		id: '',
		email: '',
		firstName: '',
		lastName: '',
		phone: '',
		// pin: '',
		POS: null,
	},

	type: '',
	permissions: utils.defaultPermissions(),

	token: '',
	refreshToken: '',
	firebaseToken: '',
	isNewSession: true,

	page: 'Login',
	doCacheToken: true,

	isLocked: false,
	status,
}

export const login = createAsyncThunk('auth/login', async (user, thunkAPI) => {
	try {
		const res = await axios.post(`/merchant/login`, { ...user })
		if (res.status == 200) {
			if (res.data.message == 'INCOMPLETE_PROFILE') {
				thunkAPI.dispatch(setToken(res.data))

				thunkAPI.dispatch(getBusinessInfoSignup())
				return utils.rejectWithValue(thunkAPI, null, {
					message: res.data.message,
					status: res.status,
					debug: true,
				})
			}
			thunkAPI.dispatch(getPersonalDetails(res.data.token))
			return res.data
		}

		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
			debug: true,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err, { debug: true })
	}
})

export const forgotPassword = createAsyncThunk('auth/forgotPassword', async (user, thunkAPI) => {
	try {
		const res = await axios.post(`/forgot-password`, { ...user, type: 'merchant' })
		if (res.status == 200) {
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const getRefreshedToken = createAsyncThunk(
	'auth/getRefreshedToken',
	async (payload, thunkAPI) => {
		try {
			const { user, refreshToken, currBranch } = thunkAPI.getState().auth
			//  utils.getAuth()
			if (!refreshToken)
				return utils.rejectWithValue(thunkAPI, null, {
					message: 'Null token',
					callback: logout,
					logout: true,
				})

			const res = await axios.post(`/app/token`, {
				email: user.email,
				type: 'merchant',
				refreshToken,
				branch: currBranch,
			})

			if (res.status == 200) {
				thunkAPI.dispatch(getPersonalDetails(res.data.token))
				return res.data
			}

			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
				callback: logout,
				logout: true,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err, { callback: logout, logout: true })
		}
	}
)

export const getPersonalDetails = createAsyncThunk(
	'auth/getPersonalDetails',
	async (token, thunkAPI) => {
		try {
			if (!token) return utils.rejectWithValue(thunkAPI, null, { logout: true })

			const res = await axios.get(`/merchant/details/personal`, {
				headers: { Authorization: `Bearer ${token}` },
			})

			if (res.status == 200) {
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)

export const editPersonalDetails = createAsyncThunk(
	'auth/editPersonalDetails',
	async (details, thunkAPI) => {
		try {
			const { token } = utils.getAuth(thunkAPI.getState())
			if (!token) return utils.rejectWithValue(thunkAPI, null, { logout: true })

			const res = await axios.put('/merchant/edit/personal-details', details, {
				headers: { Authorization: `Bearer ${token}` },
			})

			if (res.status == 200) {
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)
export const resetPassword = createAsyncThunk('auth/resetPassword', async (params, thunkAPI) => {
	try {
		const res = await axios.post('/reset-password', {
			...params.credentials,
			hash: params.hash,
		})

		if (res.status == 200) {
			return res.data
		}

		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
			callback: logout,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err, { callback: logout })
	}
})

export const setPin = createAsyncThunk('auth/setPin', async (pin, thunkAPI) => {
	try {
		const { user } = utils.getAuth(thunkAPI.getState())
		const { email } = thunkAPI.getState().signup
		const res = await axios.post('/merchant/set-pin', {
			email: user.email || email,
			pin,
		})

		if (res.status == 200) {
			return res.data
		}

		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
			callback: logout,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err, { callback: logout })
	}
})

export const unlockUsingPin = createAsyncThunk('auth/unlockUsingPin', async (pin, thunkAPI) => {
	try {
		const { token } = utils.getAuth(thunkAPI.getState())
		const res = await axios.post(
			'/merchant/unlock',
			{
				pin,
			},
			{ headers: { Authorization: `Bearer ${token}` } }
		)

		if (res.status == 200) {
			return res.data
		}

		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const addNotifDevice = createAsyncThunk('auth/addNotifDevice', async (params, thunkAPI) => {
	try {
		const { user, token, firebaseToken } = thunkAPI.getState().auth

		if (!token) {
			return thunkAPI.rejectWithValue({ data: { message: 'Null token' } })
		}
		const res = await axios.post(
			`/add-service-device`,
			{
				id: user.id,
				token: firebaseToken,
				// token: thunkAPI.getState().auth.firebaseToken,
			},
			{ headers: { Authorization: `Bearer ${token}` } }
		)

		if (res.status == 200) {
			thunkAPI.dispatch(setFirebaseToken('sent'))
			return res
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
			callback: logout,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err, { callback: logout })
	}
})
export const getFirebaseToken = createAsyncThunk(
	'auth/getFirebaseToken',
	async (params, thunkAPI) => {
		try {
			const { user } = thunkAPI.getState().auth
			await init(window.navigator, token => thunkAPI.dispatch(setFirebaseToken(token)))
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err, { callback: logout })
		}
	}
)

export const slice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		clearState: (state, { payload }) => {
			utils.clearState(state, status, payload)
		},
		logout: state => {
			localStorage.removeItem('token')
			localStorage.removeItem('refreshToken')
			localStorage.removeItem('user')

			sessionStorage.removeItem('token')
			sessionStorage.removeItem('refreshToken')
			sessionStorage.removeItem('user')
			sessionStorage.removeItem('currBranch')

			// // Login
			// state.user = {
			// 	id: 'default',
			// 	email: '',
			// 	firstName: '',
			// 	lastName: '',
			// }
			// state.currBranch = ''

			// // Tokens
			// state.token = ''
			// state.refreshToken = ''
			// state.page = 'Login'

			const keys = Object.keys(initialState)
			keys.forEach(key => {
				state[key] = initialState[key]
			})
		},
		loadSignup: state => {
			state.page = 'Sign Up'
		},
		loadLogin: state => {
			state.page = 'Login'
		},
		loadForgotPassword: state => {
			state.page = 'Forgot Password?'
		},
		updateUser: (state, { payload }) => {
			state.user = { ...state.user, ...payload }
		},
		initCachedUser: state => {
			let user = sessionStorage.getItem('user')
				? JSON.parse(sessionStorage.getItem('user'))
				: null
			let currBranch = sessionStorage.getItem('currBranch')
			let token = sessionStorage.getItem('token')
			let refreshToken = sessionStorage.getItem('refreshToken')

			if (!token || !refreshToken || !user || !currBranch) {
				user = JSON.parse(localStorage.getItem('user'))
				token = localStorage.getItem('token')
				refreshToken = localStorage.getItem('refreshToken')
				currBranch = localStorage.getItem('currBranch')

				if (token && refreshToken) {
					state.isNewSession = false
				}
			}

			state.user = user ? user : { id: 'default' }
			state.token = token
			state.refreshToken = refreshToken
			state.currBranch = currBranch

			return state
		},
		toggleDoCacheToken: (state, { payload }) => {
			if (payload != undefined) {
				state.doCacheToken = payload
				return
			}
			state.doCacheToken = !state.doCacheToken
		},

		setBranch: (state, { payload }) => {
			state.currBranch = payload
			sessionStorage.setItem('currBranch', payload)
		},
		setLocked: (state, { payload }) => {
			state.isLocked = true
		},
		setFirebaseToken: (state, { payload }) => {
			state.firebaseToken = payload
		},
	},
	extraReducers: {
		/*
    Login
    */
		[login.fulfilled]: (state, { payload }) => {
			const { _id, data, token, refreshToken, userType, permissions } = payload

			utils.handleSuccess(state.status.login, { message: 'Login successful', status: 200 })

			// Tokens
			state.token = token
			state.refreshToken = refreshToken
			state.user.id = _id
			state.currBranch = data
			state.type = userType
			state.permissions =
				userType == 'merchant' ? utils.defaultPermissions('merchant') : permissions
			state.isLocked = false

			if (state.doCacheToken) {
				// Local Storage
				localStorage.setItem('token', token)
				localStorage.setItem('refreshToken', refreshToken)
				localStorage.setItem('user', JSON.stringify({ id: data }))
			}
			sessionStorage.setItem('token', token)
			sessionStorage.setItem('refreshToken', refreshToken)
			sessionStorage.setItem('user', JSON.stringify({ id: data }))
			sessionStorage.setItem('currBranch', state.currBranch)

			return state
		},
		[login.rejected]: (state, { payload }) =>
			utils.handleError(state.status.login, payload?.data),
		[login.pending]: state => utils.handleLoading(state.status.login, 'Logging in...'),

		/*
    Forgot Password
    */
		[forgotPassword.fulfilled]: (state, { payload }) => {
			const { message } = payload
			utils.handleSuccess(state.status.forgotPassword, {
				message: message,
				status: 200,
			})

			return state
		},
		[forgotPassword.rejected]: (state, { payload }) =>
			utils.handleError(state.status.forgotPassword, payload?.data),
		[forgotPassword.pending]: state =>
			utils.handleLoading(state.status.forgotPassword, 'Sending email...'),

		/*
    Get Refreshed Token
     */

		[getRefreshedToken.fulfilled]: (state, { payload }) => {
			const { _id, data, token, refreshToken, userType, permissions } = payload

			utils.handleSuccess(state.status.getRefreshedToken, {
				message: 'Login successful',
				status: 200,
			})

			// Tokens
			state.token = token
			state.refreshToken = refreshToken
			state.user.id = _id // userType == 'merchant' ? data.data : data._id
			state.type = userType
			state.permissions =
				userType == 'merchant' ? utils.defaultPermissions('merchant') : permissions

			// Let selected branch persist through refresh
			state.currBranch = sessionStorage.getItem('currBranch') || data

			const localToken = localStorage.getItem('token')
			const localRefreshToken = localStorage.getItem('refreshToken')

			if (!state.isNewSession || (localToken && localRefreshToken)) {
				localStorage.setItem('token', token)
				localStorage.setItem('refreshToken', refreshToken)
			}
			sessionStorage.setItem('token', token)
			sessionStorage.setItem('refreshToken', refreshToken)
			sessionStorage.setItem('currBranch', state.currBranch)

			return state
		},
		[getRefreshedToken.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getRefreshedToken, payload?.data),
		[getRefreshedToken.pending]: state => utils.handleLoading(state.status.getRefreshedToken),

		/*
		Get Personal Details
		*/
		[getPersonalDetails.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			const user = {
				email: data.email.value,
				firstName: data.firstName,
				lastName: data.lastName,
				phone: data.phone,
				// pin: data.pin,
				POS: data.POS,
			}

			state.user = { ...state.user, ...user }

			const localToken = localStorage.getItem('token')
			const localRefreshToken = localStorage.getItem('refreshToken')

			if (!state.isNewSession || (localToken && localRefreshToken)) {
				localStorage.setItem('user', JSON.stringify(user))
			}
			sessionStorage.setItem('user', JSON.stringify(user))
			utils.handleSuccess(state.status.getPersonalDetails, { message: message, status: 200 })

			return state
		},
		[getPersonalDetails.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getPersonalDetails, payload?.data),
		[getPersonalDetails.pending]: state => utils.handleLoading(state.status.getPersonalDetails),

		/*
		Edit Personal Details
		*/
		[editPersonalDetails.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			utils.handleSuccess(state.status.editPersonalDetails, { message: message, status: 200 })

			return state
		},
		[editPersonalDetails.rejected]: (state, { payload }) =>
			utils.handleError(state.status.editPersonalDetails, payload?.data),
		[editPersonalDetails.pending]: state =>
			utils.handleLoading(state.status.editPersonalDetails),

		/*
		Reset Password
		*/
		[resetPassword.fulfilled]: (state, { payload }) => {
			const { message } = payload

			utils.handleSuccess(state.status.resetPassword, { message: message, status: 200 })

			return state
		},
		[resetPassword.rejected]: (state, { payload }) =>
			utils.handleError(state.status.resetPassword, payload?.data),
		[resetPassword.pending]: state =>
			utils.handleLoading(state.status.resetPassword, 'Setting password...'),

		/*
		Set Pin
		*/
		[setPin.fulfilled]: (state, { payload }) => {
			const { message } = payload

			utils.handleSuccess(state.status.setPin, { message: message, status: 200 })

			return state
		},
		[setPin.rejected]: (state, { payload }) =>
			utils.handleError(state.status.setPin, payload?.data),
		[setPin.pending]: state => utils.handleLoading(state.status.setPin, 'Setting pin...'),

		/*
		Set Pin
		*/
		[unlockUsingPin.fulfilled]: (state, { payload }) => {
			const { message } = payload
			state.isLocked = false

			utils.handleSuccess(state.status.unlockUsingPin, { message: message, status: 200 })

			return state
		},
		[unlockUsingPin.rejected]: (state, { payload }) =>
			utils.handleError(state.status.unlockUsingPin, payload?.data),
		[unlockUsingPin.pending]: state =>
			utils.handleLoading(state.status.unlockUsingPin, 'Unlocking...'),
	},
})

export const {
	clearState,
	loadLogin,
	loadSignup,
	loadForgotPassword,
	updateUser,
	initCachedUser,
	logout,
	toggleDoCacheToken,
	setBranch,
	setLocked,
	setFirebaseToken,
} = slice.actions

export default slice.reducer
